export enum UserNotificationType {
  Commenting = 'commenting_mention',
  Extract = 'Extract'
}